module.exports = __webpack_public_path__ + "media/images/vector-113@2x-94e11ddf13c34578b1a314d81fc5888a.png";